// Don't interact with the state directly. Actions use mutation to change the state.
// Actions carry out asynchronous operations
import { eventsCollection } from "@/firebase";
import _orderBy from "lodash/orderBy";

const diceEvents = ["dicesChange", "diceHold", "diceUnhold"];

const moduleActions = {
  fetchEvents({ commit, state }, roomId) {
    eventsCollection.doc(roomId).onSnapshot(snapshot => {
      if (snapshot.data()) {
        let events = _orderBy(snapshot.data().events, ["timestamp"], ["desc"]);

        if (events.length > state.limit) {
          events = events.splice(0, state.limit / 2);
        }
        commit("setEvents", { roomId, events });
      }
    });
  },
  pushEvent({ state }, { roomId, type, data, username }) {
    const obj = {
      events: state.events[roomId] || []
    };

    const event = {
      type: type,
      timestamp: Date.now()
    };

    if (data) {
      event.data = data;
    }

    if (username) {
      event.username = username;
    }

    obj.events.push(event);

    if (diceEvents.indexOf(type) !== -1) {
      this.dispatch("rooms/updateRoom", { roomId, data });
    }

    eventsCollection.doc(roomId).set(obj);
  }
};

export default moduleActions;
